import{useContext as t}from"react";import{AdvertDetailContext as e}from"../contexts/index.js";const o=()=>t(e);export{o as useAdvertDetailContext};
